import { render, staticRenderFns } from "./AttentionDetection.vue?vue&type=template&id=9b0e3c82&scoped=true"
import script from "./AttentionDetection.vue?vue&type=script&lang=js"
export * from "./AttentionDetection.vue?vue&type=script&lang=js"
import style0 from "./AttentionDetection.vue?vue&type=style&index=0&id=9b0e3c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0e3c82",
  null
  
)

export default component.exports